const SUCCESS = [201, 200];

const REGISTER_WRONG = [400];

export default {
  SUCCESS,
  REGISTER_WRONG,
};
